var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('section',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12 col-sm-12 col-md-10 col-lg-10 col-md-offset-1"},[_c('PageText',_vm._b({},'PageText',_vm.text,false))],1)])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }